import React, { FC, ReactNode } from 'react';
import { Button } from '../Button';
import s from './ButtonGrid.scss';

export interface ButtonGridItem {
  key: string;
  value: string;
  label: string;
  onClick: (value: string) => void;
  icon?: ReactNode;
  dataHook?: string;
}

export interface ButtonGridProps {
  items: ButtonGridItem[];
  selectedValue?: string;
  className?: string;
  buttonClassName?: string;
  isDisabled?: boolean;
}

export const ButtonGrid: FC<ButtonGridProps> = ({
  items,
  selectedValue,
  className,
  buttonClassName,
  isDisabled = false,
}) => {
  return (
    <div className={`${s.buttonGrid} ${className || ''}`}>
      {items.map(({ key, value, label, onClick, icon, dataHook }) => (
        <Button
          key={key}
          onClick={() => onClick(value)}
          label={label}
          icon={icon}
          className={buttonClassName}
          isSelected={selectedValue === value}
          isDisabled={isDisabled}
          dataHook={dataHook}
        />
      ))}
    </div>
  );
};
